import { getCmsSpecial } from 'services/api/cms/special';
import { SET_SPECIAL, CLEAR_SPECIAL } from '../actions/specials';

export const setCmsSpecial = data => ({
  type: SET_SPECIAL,
  data,
});

export const clearSpecial = () => ({
  type: CLEAR_SPECIAL,
});

export const fetchCmsSpecial = params => dispatch =>
  getCmsSpecial(params)
    .then(data => {
      dispatch(setCmsSpecial(data.response));
      return data.response;
    })
    .catch(e => {
      console.warn('ERR:', e);
    });
